export const processRequestRouter = [
  // {
  //   path: 'processRequests',
  //   name: 'Process Request List',
  //   component: () => import('./pages/ProcessRequests')
  // }
]
